var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var FormMixin = require('ES/widgets/forms/FormMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var ServicesUtils = require('ES/utils/ServicesUtils');
var SlideOpenDown = require('../../widgets/SlideOpenDown');
var HorizontalFields = require('ES/widgets/HorizontalFields');
var AuthedUserSession = require('../../../utils/AuthedUserSession');
var FormUtils = require('../../../utils/FormUtils');


const DaForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props.sid + JSON.stringify(this.getInitialValues(props));
    },
    getInitialValues: function (props) {
        var config = props.config || {};
        return {
            karmacrm_api_token: config.karmacrm_api_token || '',
        };
    },
    buildFields: function () {
        return {
            karmacrm_api_token: {
                label: 'karmaCRM API token',
                type: 'text',
                help_text: 'example: NDzJcvqdNUoqZ2oXQvqq',
                tooltip: 'Enter your karmaCRM API token.',
                validate: FormUtils.optional
            }
        };
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),
    render: function () {
        var fields = this.buildFields();
        var errors = this.state.errors || {};
        var changes_made = this._form_areChangesMade();

        return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
            HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            }),
            SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
        );
    }
});


module.exports = dd.createClass({
    mixins: [ServicesUtils.RadioAjaxMixin("read_Thirdpartyconnection_KarmaCRM_config", "save_Thirdpartyconnection_KarmaCRM_config")],
    getInitialState: function () {
        return {sid: -1, successMessage: null, failureMessage: null};
    },
    __RadioAjax_key_read_Thirdpartyconnection_KarmaCRM_config: function () {
        return this.state.sid;
    },
    __RadioAjax_key_save_Thirdpartyconnection_KarmaCRM_config: function () {
        return this.state.sid;
    },
    __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_success: function () {
        this.setState({successMessage: 'API Key saved.', failureMessage: null});
    },
    __RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_failure: function (sid, data) {
        this.setState({successMessage: null, failureMessage: data});
    },

    componentWillReceiveProps: function (props) {
        this.__loadForSid(props.selected_sid);
    },
    componentDidMount: function () {
        this.__loadForSid(this.props.selected_sid);
    },
    __loadForSid: function (sid) {
        if (sid !== this.state.sid) {
            this.setState({sid: sid, failureMessage: "", successMessage: ""}, function () {
                radio('read_Thirdpartyconnection_KarmaCRM_config').broadcast(sid);
            });
        }
    },
    __onSubmit: function (data) {
        radio('save_Thirdpartyconnection_KarmaCRM_config').broadcast(this.state.sid, data, this.__RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_success, this.__RadioAjax_read_Thirdpartyconnection_KarmaCRM_config_failure);
    },
    render: function () {
        var Displaylists = this.props.Displaylists;

        var sid = this.state.sid;
        var ajax_read = this.state.read_Thirdpartyconnection_KarmaCRM_config; //this doesn't appear to be hooked up
        var ajax_save = this.state.save_Thirdpartyconnection_KarmaCRM_config; //this doesn't appear to be hooked up
        var successMessage = this.state.successMessage;
        var failureMessage = this.state.failureMessage;

        var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
            return spkr.sid == sid;
        }, this);
        return dd.div(null,
            LoadingWrap({
                    is_loading: ajax_read.waiting || ajax_save.waiting,
                    glass: true
                },
                dd.h3(null, 'karmaCRM connector for ',
                    dd.span({className: 'nametag'},
                        _.get(AuthedUserSession, "MY_USERNAME")
                    ),
                    ' + ',
                    dd.span({className: 'nametag'},
                        _.get(speaker, "name_full")
                    )
                ),
                dd.p({className: 'text-muted'},
                    'NOTE: The setting for this connector is unique to the user-speaker combination. Each user on a speaker\'s account will need to connect this individually.'
                ),
                // ErrorAlert({message: ajax_read.error_message}),
                // ErrorAlert({message: ajax_save.error_message}),
                ErrorAlert({message: failureMessage}),
                (_.isEmpty(successMessage)) ? null : dd.div({className: 'alert alert-success'},
                    successMessage
                ),
                DaForm({
                    sid: sid,
                    config: ajax_read.data,
                    onSubmit: this.__onSubmit
                }),
                dd.div({className: "row", style: {marginTop: "4em"}},
                    dd.div({className: "col-sm-12 text-left"},
                        dd.p({className: "text-muted"},
                            "Need help ",
                            dd.a({href: "http://support.karmacrm.com/users/settings/account-settings-profile-details", target: "_blank"},
                                "finding your karmaCRM API key?")
                        )
                    ),
                    dd.div({className: "col-sm-12 text-left"},
                        dd.p({className: "text-muted"},
                            "To disconnect from karmaCRM, clear out your API token above and click SAVE."
                        )
                    )
                )
            )
        )
            ;
    }
});





// WEBPACK FOOTER //
// ./src/components/account_settings/connect/KarmaCRM.js